import axios from "config/axios";
import { GenericListResponse, Shop } from "shared/types";

const ENDPOINT = "/shop";

export const getAllShops = () => axios.get<GenericListResponse<Shop>>(`${ENDPOINT}/get-all`);
